const templateUrl = require('./holdings_report.html.slim')
declare var moment;
declare var angular
import { sumBy } from 'lodash'

class HoldingsReportController {
  static $inject = [
    '$routeParams',
    'Accounts',
    'Positions',
  ]

  public account
  public positions: any[]
  public totalValue: number
  public totalAverage: number
  public orderBy: string
  public reverse: boolean
  public onSort

  private _date

  constructor(public $routeParams, public Accounts, public Positions) {
    this.account = this.Accounts.get({ id: $routeParams.id, basic: true })
    this.onSort = (tableSort) => {
      const isNumber = ['allocation', 'quantity', 'averagePrice', 'averageValue', 'priceCad', 'valueCad'].indexOf(tableSort.orderBy) !== -1
      this.orderBy = isNumber ? value => parseFloat(value[tableSort.orderBy]) : tableSort.orderBy
      this.reverse = tableSort.reverse
    }
  }

  get date() { return this._date; }
  set date(date) {
    if (date) {
      this.positions = this.Positions.query({
        id: this.$routeParams.id,
        date: moment(date, ['MM/YYYY', 'DD/MM/YYYY']).format('YYYY-MM-DD'),
        exact_date: date.creationData().format.includes('DD')
      },
        (p) => this.positionsUpdated(p)
      )
      this._date = date
    }
  }

  get asOfDate() {
    if (this.positions == null || !(this.positions.length > 0)) return
    if (typeof this.positions[0].asOfDate === 'undefined') return this.positions[0].insertDate
    return this.positions[0].asOfDate
  }

  private positionsUpdated(positions) {
    this.totalValue = sumBy(positions, (p) => +p.valueCad)
    positions.forEach((p) => {
      p.allocation = p.valueCad / this.totalValue
    })
    this.totalAverage = sumBy(positions, (p) => +p.averageValue)
  }
}

export default ['$routeParams', 'Accounts', 'Positions', (a, b, c) => new HoldingsReportController(a, b, c)]

angular.module('wbComponents').directive('holdingsReport', function() {
  return {
    restrict: 'E',
    controller: HoldingsReportController,
    controllerAs: 'ctrl',
    bindToController: true,
    templateUrl,
  }
})
